import React from "react";
import QuestionRenderer from "./questions/QuestionRenderer";
import ReferenceInput from "./ReferenceInput";
import { groupQuestionsForLayout, isQuestionVisible } from "./surveyUtils";

/**
 * Read-only stacked answers for a previous submission.
 *
 * @param {Object} props
 * @param {object} props.definition
 * @param {Record<string, unknown>} props.answers
 * @returns {JSX.Element}
 */
export default function SurveyAnswersReadOnly({ definition, answers }) {
  const pages = definition?.pages || [];
  return (
    <div className="flex flex-col gap-8">
      {pages.map((page) => {
        const questions = (page.questions || []).filter((q) => isQuestionVisible(q, answers || {}));
        if (questions.length === 0) return null;
        const layoutItems = groupQuestionsForLayout(questions);
        return (
          <div key={page.id} className="flex flex-col gap-6">
            {page.title ? (
              <h3 className="text-sm font-semibold uppercase tracking-wide text-text-muted">
                {page.title}
              </h3>
            ) : null}
            {layoutItems.map((item) => {
              if (item.kind === "reference") {
                return (
                  <ReferenceInput
                    key={item.prefix}
                    title={item.title}
                    questions={item.questions}
                    answers={answers || {}}
                    readOnly
                    onChange={() => {}}
                  />
                );
              }
              const { question } = item;
              return (
                <QuestionRenderer
                  key={question.id}
                  question={question}
                  value={(answers || {})[question.id]}
                  readOnly
                  onChange={() => {}}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
